export default __webpack_public_path__ + "static/SR India - Safety Data Sheet - Caramel Color (Liquid)-28453c6f32033c97f3c43228910aa585.pdf";